import { render } from "./TransferForm.vue?vue&type=template&id=c337b464&ts=true"
import script from "./TransferForm.vue?vue&type=script&lang=ts"
export * from "./TransferForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__